export const PATIENT_SESSION = "patientSession";